import React from 'react';
import { Box } from '@mui/material';
import JobDetailsCard from './JobDetailsCard';
import ApplicationStatusCard from './ApplicationStatusCard';

const JobInfoSection = ({ application }) => {
  if (!application) return null;

  return (
    <Box>
      {/* Job Information */}
      <JobDetailsCard job={application.job} />

      {/* Application Status */}
      <ApplicationStatusCard application={application} />

      {/* Organization Information */}
      {/* {application.job.about_organisation && (
        <OrganizationCard organization={application.job.about_organisation} />
      )} */}
    </Box>
  );
};

export default JobInfoSection;